import createTypeDecorator from '../decorators/createTypeDecorator'
// import {
//   validateHash,
// } from 'pw-validators'

export const HASH = Symbol("schemer.types.HASH")
export const HASH_MD5 = Symbol("schemer.types.HASH_MD5")
export const HASH_SHA1 = Symbol("schemer.types.HASH_SHA1")
export const HASH_SHA256 = Symbol("schemer.types.HASH_SHA256")
export const HASH_SHA512 = Symbol("schemer.types.HASH_SHA512")

// const validateHashMD5 = val => validateHash(val, 'md5')
// const validateHashSHA1 = val => validateHash(val, 'sha1')
// const validateHashSHA256 = val => validateHash(val, 'sha256')
// const validateHashSHA512 = val => validateHash(val, 'sha512')

export const hash = createTypeDecorator(HASH, {
  // input: {
  //   validate: validateHash
  // }
})

export const hashMd5 = createTypeDecorator(HASH_MD5, {
  // input: {
  //   validate: validateHashMD5
  // }
})

export const hashSha1 = createTypeDecorator(HASH_SHA1, {
  // input: {
  //   validate: validateHashSHA1
  // }
})

export const hashSha256 = createTypeDecorator(HASH_SHA256, {
  // input: {
  //   validate: validateHashSHA256
  // }
})

export const hashSha512 = createTypeDecorator(HASH_SHA512, {
  // input: {
  //   validate: validateHashSHA512
  // }
})